import BankAccountDTO from "features/payments/dtos/BankAccountDTO";
import { Currency } from "../enums/currency";
import { convertCodeShortToLong } from "features/shared/helpers/languageHelper";
import i18next from "i18next";
import CustomerBankAccountDTO from "features/customer/dtos/CustomerBankAccountDTO";

// Načte aktuální zvolený jazyk
const getLanguage = () => i18next.language || window.localStorage.i18nextLng;
const longLanguageCode = convertCodeShortToLong(getLanguage());

export const formatPrice = (amount: number, currency: Currency, decimalPlaces?: number) => {
  if (currency && currency !== "Undefined") {
    let formatter = new Intl.NumberFormat(longLanguageCode, {
      style: "currency",
      currency: currency,
      maximumFractionDigits: decimalPlaces !== undefined ? decimalPlaces : 0,
      minimumFractionDigits: decimalPlaces !== undefined ? decimalPlaces : 0
    });
  
    return formatter.format(amount);
  }
  
  return "-";
}

export const formatDate = (date: Date | string, formatOptions?: Intl.DateTimeFormatOptions, language?: string) => {
  let dateObj = new Date(date);
  const languageCode = language ? convertCodeShortToLong(language) : longLanguageCode;


  if (!isNaN(dateObj.getTime())) {
    return dateObj.toLocaleDateString(languageCode, formatOptions);
  }
}

export const formatBankAccount = (bankAccount: BankAccountDTO | CustomerBankAccountDTO) => {
  if (bankAccount) {
    let preAccountNumber = bankAccount.preAccountNumber ? `${bankAccount.preAccountNumber}-` : "";
    let bankCode = bankAccount.bankCode ? `/${bankAccount.bankCode}` : "";

    return `${preAccountNumber}${bankAccount.accountNumber}${bankCode}`;
  }
  
  return "";
}

export const formatNumber = (amount: number, decimalPlaces?: number, unit?: string) => {
  if (amount !== undefined) {
    let formatter = new Intl.NumberFormat(undefined, {
      maximumFractionDigits: decimalPlaces !== undefined ? decimalPlaces : 0,
      minimumFractionDigits: decimalPlaces !== undefined ? decimalPlaces : 0
    });

    let formattedNumber = formatter.format(amount);

    if (unit) {
      return `${formattedNumber} ${unit}`;
    } else {
      return formattedNumber;
    }
  }

  return "";
}